import { gridSize } from "theme/config/grid";
import styled from "theme/libs/styled";

const ScalingGridWrapper = styled("div")();

ScalingGridWrapper.defaultProps = {
    columnGap: [gridSize.mobile.gap, null, null, gridSize.tablet.gap, null, gridSize.desktop.gap],
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    width: "100%",
};

export default ScalingGridWrapper;
